module.exports = __webpack_public_path__ + "img/mixBox_bg.07fe3171.png";